export class Environment {
  constructor() {
  }

  async setup() {
  }
}
